import Notifications from './Notifications';
import './Notifications.scss';

export default Notifications;
